<template>
  <div>
    <b-modal id="faq-modal" ref="faq-modal-ref" hide-footer title="Frequently Asked Questions">
      <div v-if="level === 'categories'">
        <span class="faq-modal-inst">Please select the area your question relates to:</span>
        <div class="faq-modal-btn-container">
          <div v-for="(item, index) in categories" :key="index">
            <b-button class="faq-modal-btn" @click="onCategoryClick(item._id)">
              {{ item._id }}
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="level === 'areas'">
        {{ category }} <br>
        <span class="faq-modal-inst">Please select the sub category your question relates to:</span>
        <b-button class="faq-modal-back-btn w-25" @click="goBack()">
          <span class="material-icons">keyboard_backspace </span>
          <span>Back To Main Sections</span>
        </b-button>
        <br><br>
        <div class="faq-modal-btn-container">
          <div v-for="(item, index) in areas" :key="index">
            <b-button class="faq-modal-btn faq-modal-btn-area m-1" @click="onAreaClick(item._id)">
              {{ item._id }}({{ item.Count }})
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="level === 'questions'">
        {{ area }} <br>
        <b-button class="faq-modal-back-btn w-25" @click="goBack()">
          <span class="material-icons">keyboard_backspace </span>
          <span>Back To Main Sections</span>
        </b-button>
        Please select from one of these options:
        <br><br>
        <div v-for="(item, index) in questions" :key="index">
          <b-button class="faq-modal-btn faq-modal-btn-question" @click="onAQuestionClick(index)">
            <i class="material-icons vtd-icon-3 mr-3">add_circle_outline</i>
            <span>{{ item.question }}</span>
          </b-button>
          <div v-if="question === index">
            <div class="faq-modal-answer" v-html="item.answer"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  props: {
    showEtrail: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      level: 'categories',
      question: null
    }
  },
  computed: {
    ...mapGetters({
      categories: 'faq/getCategories',
      areas: 'faq/getAreas',
      questions: 'faq/getQuestions',
      category: 'faq/getCurrentCategory',
      area: 'faq/getCurrentArea'
    })
  },
  watch: {
    areas: function () {
      if (this.areas && this.areas.length === 1) {
        this.level = 'questions'
        this.loadQuestions(this.areas[0]._id)
      }
    }
  },
  created: function () {
    this.loadCategories()
  },
  methods: {
    ...mapActions({
      loadCategories: 'faq/loadCategoriesAction',
      loadAreas: 'faq/loadAreasAction',
      loadQuestions: 'faq/loadQuestionsAction',
      setCurrentCategory: 'faq/setCurrentCategoryAction',
      setCurrentArea: 'faq/setCurrentAreaAction',
    }),
    showModal: function () {
      this.level = 'categories'
      this.setCurrentCategory(null)
      this.setCurrentArea(null)
      this.question = null
      this.$refs['faq-modal-ref'].show()
    },
    onCategoryClick: function (category) {
      this.level = 'areas'
      this.loadAreas(category)
    },
    onAreaClick: function (area) {
      this.level = 'questions'
      this.loadQuestions(area)
    },
    onAQuestionClick: function (i) {
      this.question = i
    },
    toEtrail: function () {
      this.$refs['faq-modal-ref'].hide()
      this.showEtrail()
    },
    onYesClick: function () {
      this.$refs['faq-modal-ref'].hide()
    },
    goBack: function () {
      this.level = 'categories'
    }
  },
};
</script>

<style>
@import '../styles.scss';
</style>
